import React, { useEffect, useState } from 'react';
import { cloneDeep } from 'lodash-es';
import Util from '../../../../script/util';
import './index.scss';

const ONE_DAY_TIME = 24 * 60 * 60 * 1000; // 一天的毫秒数

const CustomCarousel = ({ list, index, afterChange, showTime }) => {
  const [activeIndex, setActiveIndex] = useState(index);
  const [carList, setCarList] = useState([]); // 轮播所有的套系列表

  useEffect(() => {
    const copyList = cloneDeep([...(list || [])]);
    for (let i = 0; i < copyList.length; i++) {
      const item = copyList[i];
      if (item.index == null) item.index = i;
      if (item.index < index) {
        item.index = item.index + copyList.length - index;
      } else {
        item.index = item.index - index;
      }
    }
    setCarList(copyList);
  }, [list, index]);

  // 切换套系轮播
  const onChangeSuitCarouselIndex = (type) => {
    const copyCarList = cloneDeep(carList);
    const len = copyCarList.length;

    let index = activeIndex - type;
    if (index < 0) index = len - 1;
    if (index >= len) index = 0;
    setActiveIndex(index);
    afterChange(index);

    for (let i = 0; i < len; i++) {
      const oldid = copyCarList[i].index;

      let newId = oldid + 1;
      if (type === 1) {
        newId = oldid + 1 >= len ? 0 : oldid + 1;
      } else if (type === -1) {
        newId = oldid - 1 < 0 ? len - 1 : oldid - 1;
      }
      copyCarList[i].index = newId;
    }
    setCarList(copyCarList);
  };

  // 倒计时时间
  const renderTimeDown = (date) => {
    const time = Util.formatDuring(date * 1000);
    if (date <= 0) {
      return `0天`;
    }
    if (date * 1000 > ONE_DAY_TIME) {
      return `${time.days}天${time.hours}时`;
    } else {
      return `${time.hours}时${time.minutes}分`;
    }
  };

  const returnCarouselIndex = (index) => {
    const len = carList.length;
    let curIndex = index;
    const diff = len - curIndex;
    if (curIndex < 3) {
    } else if (diff < 3) {
      curIndex = 5 - diff;
    } else {
      curIndex = 5;
    }
    return `carousel-item-${curIndex}`;
  };
  return (
    <div
      className="custom-carousel"
      style={{ '--carousel-height': showTime ? '200px' : '180px' }}
    >
      <div className="custom-carousel-box">
        {carList?.length > 1 && (
          <div
            className="carousel-prev"
            onClick={() => onChangeSuitCarouselIndex(-1)}
          />
        )}
        {carList.map((item, index) => (
          <div
            key={item.carConfigId}
            className={Util.classNames(
              'carousel-item',
              item.index,
              returnCarouselIndex(item.index)
            )}
          >
            <div className="cover">
              <img
                src={Util.transImgUrl(item.carIcon, '224x224')}
                alt={item.carName}
              />
            </div>
            <div className={`name ${activeIndex == index ? 'bg' : ''}`}>
              <p>{item.name}</p>
            </div>
            {item.expireSeconds && showTime && activeIndex == index ? (
              <div className="time">
                <p>剩余有效期：{renderTimeDown(item.expireSeconds)}</p>
              </div>
            ) : null}
          </div>
        ))}
        {carList?.length > 1 && (
          <div
            className="carousel-next"
            onClick={() => onChangeSuitCarouselIndex(1)}
          />
        )}
        {/* 轮播指引 */}
        <div className="dots-line" />
      </div>
    </div>
  );
};

export default CustomCarousel;
